window.HUFFPOST.YouTubeIframeAPIReady = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
